export default __webpack_public_path__ + "free_trial_header.4d99f4ba.gif";